// 图书板块接口api
import request from '@/utils/request' // axios request 请求方法
import {
  apiPermission
} from '@/utils/permission' // 接口权限控制

// import appConst from '@/utils/const.js' // 项目通用常量

// 接口基础路径,用户接口和视频接口
const memberPreUrlPath = process.env.API_MEMBER_PRE_URL
const videoPreUrlPath = process.env.API_VIDEO_PRE_URL

// 接口对象
const api = {
  /// ////////////////////用户api///////////////////////
  // 用户登录，返回token
  login: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('login', roles, function () {
          request.post(`${memberPreUrlPath}/login`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 获取用户id
  getUserId: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('getUserId', roles, function () {
          request.get(`${memberPreUrlPath}/user/id`, {
            params: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 获取用户信息
  getUserInfo: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('getUserInfo', roles, function () {
          request.get(`${memberPreUrlPath}/user/info`, {
            params: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 更新密码
  userUpdatePassword: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('userUpdatePassword', roles, function () {
          request.put(`${memberPreUrlPath}/user/update/password`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 更新用户信息
  userUpdateInfo: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('userUpdateInfo', roles, function () {
          request.put(`${memberPreUrlPath}/user/update`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 添加用户
  userCreate: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('userCreate', roles, function () {
          request.post(`${memberPreUrlPath}/user/create`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  /// ////////////////////视频api///////////////////////
  // 新建视频
  videoCreate: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoCreate', roles, function () {
          request.post(`${videoPreUrlPath}/video/create`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 获取视频详情
  getVideoDetail: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('getVideoDetail', roles, function () {
          request.get(`${videoPreUrlPath}/video/detail/${params.id}`, {
            params: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 视频列表
  getVideoList: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('getVideoList', roles, function () {
          request.post(`${videoPreUrlPath}/video/list`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  /// ////////////////////视频播放列表api///////////////////////
  // 在播放列表中添加视频
  videoPlayListAddVideo: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListAddVideo', roles, function () {
          request.post(`${videoPreUrlPath}/video/play/list/add/video`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 新建播放列表
  videoPlayListCreate: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListCreate', roles, function () {
          request.post(`${videoPreUrlPath}/video/play/list/create`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 在播放列表中删除视频
  videoPlayListDeleteVideo: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListDeleteVideo', roles, function () {
          request.delete(`${videoPreUrlPath}/video/play/list/delete/video/${params.id}`, {
            data: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 播放列表视频清单
  videoPlayListDetail: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListDetail', roles, function () {
          request.get(`${videoPreUrlPath}/video/play/list/detail/${params.id}`, {
            params: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 查询播放列表
  videoPlayListList: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListList', roles, function () {
          request.post(`${videoPreUrlPath}/video/play/list/list`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 更改播放列表中视频的排序
  videoPlayListMoveVideo: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayListMoveVideo', roles, function () {
          request.put(`${videoPreUrlPath}/video/play/list/move/video/{params.id}/{params.sort}`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  /// ////////////////////视频播放记录api///////////////////////
  // 统计视频播放次数
  videoPlayRecordCount: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayRecordCount', roles, function () {
          request.post(`${videoPreUrlPath}/video/playrecord/count`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 新建记录
  videoPlayRecordCreate: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayRecordCreate', roles, function () {
          request.post(`${videoPreUrlPath}/video/playrecord/create`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 播放记录列表
  videoPlayRecordList: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayRecordList', roles, function () {
          request.post(`${videoPreUrlPath}/video/playrecord/list`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 个人学习记录
  videoPlayRecordStudyrecord: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayRecordList', roles, function () {
          request.get(`${videoPreUrlPath}/video/playrecord/studyrecord`, {
            params: params
          }).then((res) => {
            resolve(res)
          })
        })
      })
    }
  },
  // 统计所有用户的学习进度
  videoPlayRecordAllUsers: {
    roles: [],
    r: (params) => {
      const roles = []
      return new Promise((resolve, reject) => {
        apiPermission('videoPlayRecordAllUsers', roles, function () {
          request.post(`${videoPreUrlPath}/video/playrecord/count4User`, params).then((res) => {
            resolve(res)
          })
        })
      })
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js